<template>
  <div class="classroom-add">
    <el-dialog
      title="添加课室"
      :visible="dialogVisible"
      @open="dialogOpen"
      @close="dialogClose"
      width="480px"
      :close-on-click-modal="false"
      center
    >
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="课室号:" prop="classroomCode">
                <el-input
                  v-model="ruleForm.classroomCode"
                  placeholder="请输入课室号"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="课室名称:" prop="classroomName">
                <el-input
                  v-model="ruleForm.classroomName"
                  placeholder="请输入课室名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
        <!-- <div class="beaconCode">
          <div class="text">信标:</div>
          <el-tag
            :key="index"
            v-for="(beaconCode, index) in beaconCodeList"
            closable
            :disable-transitions="false"
            @close="handleClose(beaconCode)"
          >
            {{ beaconCode }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else
            class="button-new-tag"
            size="small"
            @click="showInput"
          >
            <i class="iconfont icon-add" />添加信标
          </el-button>
        </div> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogClose">取 消</el-button>
        <el-button type="primary" @click="comfrim('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
    },
  },
  inject: ["refresh"],
  created() {},
  data() {
    return {
      ruleForm: {
        classroomCode: "",
        classroomName: "",
        beaconCode: "",
      },
      rules: {
        classroomCode: [{ required: true, message: "请输入课室号", trigger: "blur" }],
        classroomName: [{ required: true, message: "请输入课室名称", trigger: "change" }],
      },
      formLabelWidth: "120px",
      // 信标
      beaconCodeList: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  methods: {
    dialogOpen() {
      this.ruleForm.classroomCode = "";
      this.ruleForm.classroomName = "";
      this.ruleForm.beaconCode = "";
      this.beaconCodeList = [];
    },
    dialogClose() {
      this.ruleForm.classroomCode = "";
      this.ruleForm.classroomName = "";
      this.ruleForm.beaconCode = "";
      this.beaconCodeList = [];
      this.$emit("update:dialogVisible", false);
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
    comfrim(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log("验证成功,下一步");
          this.ruleForm.beaconCode = this.beaconCodeList.join(",");
          // console.log("ruleForm=> ", this.ruleForm);
          let { classroomCode, classroomName, beaconCode } = this.ruleForm;
          let { id: createBy, schoolId, schoolName } = this.user;
          let submit = {
            createBy,
            schoolId,
            schoolName,
            classroomCode,
            classroomName,
          };
          // 调用接口添加教室信息
          // console.log(submit);
          this.post(this.$url.addClassroom, submit)
            .then((res) => {
              // console.log("添加教室信息==>", res);
              if (res.code == 200 && res.data != 0) {
                this.$message.success("添加成功");
                // 刷新列表
                this.refresh();
                // 关闭弹出框
                this.dialogClose();
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              // this.$message.error("添加失败，请稍后再试");
            });
          // 关闭弹出框
          // this.dialogClose();
        } else {
          return false;
        }
      });
    },
    // 信标相关
    handleClose(tag) {
      this.beaconCodeList.splice(this.beaconCodeList.indexOf(tag), 1);
      // console.log(this.beaconCodeList);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.beaconCodeList.push(inputValue);
        // console.log(this.beaconCodeList);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./classroom-add.scss";
</style>
